import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useDevice, ScopedThemeProvider } from 'seagull';
import { getDefaultTheme } from '~/constants';
export function withScaledDownFontsOnMobile(Component) {
    let { maxHeight, maxWidth } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function WithScaledDownFontsOnMobile(props) {
        const { isMobileDevice } = useDevice();
        return isMobileDevice ? /*#__PURE__*/ _jsx(ScopedThemeProvider, {
            theme: getDefaultTheme('mobile'),
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
        }) : /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
}
